/* eslint-disable */
import React, { useState } from 'react'
import Link from 'next/link'
import SearchForm from './SearchForm'
import { SearchIcon } from '@heroicons/react/solid'
import { Dropdown } from '../Header/Dropdown'
import { categories } from '../../blog.config'
interface Props {
  categories?: any
  categorySlug?: any
}

const Nav: React.FC<Props> = () => {
  const [showSearchForm, setSearchForm] = useState(false)

  return (
    <>
      {showSearchForm && (
        <div className="overlay">
          {showSearchForm && <SearchForm setShowOverLay={setSearchForm} />}
        </div>
      )}
      <div className="flex justify-center text-sm mb-4">
        <a
          onClick={() => setSearchForm(!showSearchForm)}
          className="flex items-center mx-2 font-medium uppercase cursor-pointer font-base"
        >
          <SearchIcon width={20} height={20} />
        </a>
        <Link href="/blog">
          <a
            href={`/blog`}
            className={`flex items-center uppercase cursor-pointer undefined font-bold font-heading text-lg text-gray-600 mx-2`}
          >
            Home
          </a>
        </Link>

        {categories.map(category =>
          category.subCategory ? (
            <Dropdown
              key={category.label}
              links={category.subCategory}
              label={category.label.toUpperCase()}
            />
          ) : (
            <Link key={category.label} href={`/blog/category${category.href}`}>
              <a
                href={`/blog/category${category.href}`}
                className={`flex items-center uppercase cursor-pointer undefined font-bold font-heading text-lg text-gray-600 mx-2`}
              >
                {category.label}
              </a>
            </Link>
          )
        )}
      </div>
    </>
  )
}
export default Nav
